import { push } from 'connected-react-router';
import API from '../helpers/api';
import LocalStorageHelper from '../helpers/local_storage';

export function logout() {
	return async dispatch => {
		const res = await API.auth.logout();
		LocalStorageHelper.logout();
		if (res.meta.code !== 200) {
			return;
		}
		if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat') {
			window.location.href = res.data.logout_url;
			return;
		}
		dispatch(push('/login'));
	};
}
